/* eslint-disable */
import React from "react";
import {
  Card,
  Stack,
  Text,
  Divider,
  ScrollArea,
  createStyles,
  Avatar,
  Button,
  Title,
} from "@mantine/core";
import { useGetOrg } from "api/organizations/getOrg";
import { useUser } from "hooks/useUser";
import { useNavigate } from "react-router-dom";

const useStyles = createStyles((theme) => ({
  card: {
    borderRadius: 8,
    height: "100%",
    padding: 14,
    border: `1px solid ${theme.colors.gray[3]}`,
    boxShadow: "0 6px 18px rgba(12,20,40,0.04)",
    background: theme.white,
  },
  headerRow: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: 8,
  },
  title: {
    fontSize: 18,
    fontWeight: 700,
    color: theme.colors.gray[9],
  },
  list: {
    width: "100%",
  },
  row: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    padding: "10px 6px",
    borderBottom: `1px solid ${theme.colors.gray[1]}`,
  },
  viewAllBtn: {
    height: "34px",
    borderRadius: "8px",
    padding: "6px 12px",
  },
  name: {
    fontSize: 11,
    fontWeight: 700,
    color: theme.colors.dark[8],
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },
  role: {
    fontSize: 13,
    color: theme.colors.gray[6],
    marginTop: 2,
  },
  textGroup: {
    display: "flex",
    flexDirection: "column",
    minWidth: 0,
  },
  footerSpacer: {
    height: 6,
  },
}));

type RawMember = {
  _id?: string;
  id?: string;
  firstName?: string;
  lastName?: string;
  name?: string;
  position?: string;
  role?: string;
};

export default function MemberListing({ members }: { members?: RawMember[] }) {
  const { classes } = useStyles();
  const { user } = useUser();
  const { data: org } = useGetOrg(user?.org?._id);
  const navigate = useNavigate()
  const orgMembers: RawMember[] =
    org && Array.isArray(org.members) ? (org.members as RawMember[]) : [];
  console.log("orgMembers in MemberListing", orgMembers);
  const rawList: RawMember[] =
    Array.isArray(members) && members.length
      ? members
      : orgMembers.length
      ? orgMembers
      : [
          {
            id: "demo-1",
            firstName: "Demo",
            lastName: "User",
            position: "Demo Role",
          },
        ];

  const mapMember = (m: RawMember) => {
    const first = m.firstName ?? "";
    const last = m.lastName ?? "";
    const computedName = `${first} ${last}`.trim();
    const name = computedName || m.name || "Unknown";

    const idSrc = m._id ?? m.id ?? name;
    const id = String(idSrc);

    const position = m.position ?? m.role ?? "";

    const firstInitial = (first && first[0]) ?? "";
    const lastInitial = (last && last[0]) ?? "";
    const fallbackInitial = name[0] ?? "";
    const initials = firstInitial + lastInitial || fallbackInitial;

    return { id, name, position, initials: initials.toUpperCase() };
  };

  const list = rawList.map(mapMember);

  return (
    <Card className={classes.card} radius="md">
      <div className={classes.headerRow}>
        {/* <Text className={classes.title}>Employees</Text> */}
        <Title order={3} style={{ fontSize: "18px" }}>
          Employees
        </Title>
        <Button variant="light"             onClick={() => navigate("/all-employees")}
 className={classes.viewAllBtn}>
          View All
        </Button>
      </div>

      <Divider />

      <ScrollArea style={{ height: 380, marginTop: 8 }} type="auto">
        <Stack spacing={0} className={classes.list}>
          {list.map((m) => (
            <div key={m.id} className={classes.row}>
              <Avatar radius="xl">{m.initials}</Avatar>

              <div className={classes.textGroup}>
                <Text>{m.name}</Text>
                <Text color="dimmed">{m.position}</Text>
              </div>
            </div>
          ))}
        </Stack>
      </ScrollArea>

      <div className={classes.footerSpacer} />
    </Card>
  );
}
